import { DeepPartial, TrackQueryConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_TRACK_QUERY: DeepPartial<TrackQueryConfig> = { debounceTimeInMs: 5000};
